'use client';

import React from 'react';

interface Loader360Props {
  fullScreen?: boolean;
}

export default function Loader360({ fullScreen = true }: Loader360Props) {
  return (
    <div
      className={
        fullScreen
          ? 'fixed inset-0 z-[9999] flex items-center justify-center bg-background/80 backdrop-blur-sm'
          : 'flex items-center justify-center w-full h-full min-h-[200px]'
      }
    >
      <div className="relative flex items-center justify-center">
        {/* Outer spinning ring */}
        <div className="absolute w-20 h-20 rounded-full border-4 border-transparent border-t-primary border-r-primary/50 animate-spin" />

        {/* Middle counter-spinning ring */}
        <div
          className="absolute w-14 h-14 rounded-full border-4 border-transparent border-b-primary/70 border-l-primary/30"
          style={{ animation: 'spin 1.2s linear infinite reverse' }}
        />

        {/* Inner pulsing dot */}
        <div className="absolute w-6 h-6 rounded-full bg-primary/20 animate-pulse" />

        {/* Brand label */}
        <span
          className="relative z-10 text-[10px] font-bold tracking-widest text-primary select-none"
          style={{ fontFamily: 'var(--font-ibm-plex-mono, monospace)' }}
        >
          BizzBox
        </span>
      </div>
    </div>
  );
}
